import { useNavigation } from '@react-navigation/native';
import { IpadLang, Lang } from '@w3lcome/types';
import { Header, HTMLRender } from '_/components';
import ContainerWidthLimit from '_/components/ContainerWidthLimit';
import { colors } from '_/config/theme';
import { textReplace } from '_/helpers/textReplace';
import { useCustomization } from '_/hooks/CustomizationContext';
import { useCentralizedValuesFallback } from '_/hooks/useCentralizedValuesFallback';

import { useVisit } from '_/hooks/VisitContext';
import { HomeProps } from '_/navigation/types';

import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { View, StyleSheet } from 'react-native';

const MeetingErrorScreen: React.FC = () => {
  const { customization } = useCustomization();

  const { visit, navigateToHome } = useVisit();

  const { t, i18n } = useTranslation();
  const navigation = useNavigation<HomeProps>();

  const { selectedOrFallbackCompany } = useCentralizedValuesFallback();

  const ipadMeetingErrorMessage = selectedOrFallbackCompany?.visitsConfig?.ipadMeetingErrorMessage;

  const getMessageByLang = (message: { [key in Lang]?: string } | undefined) => {
    if (!message) return '';

    if (typeof message === 'string') return message;

    const langValue =
      message[i18n.language as Lang] ||
      message[Lang.EN] ||
      message[Object.keys(message)[0] as Lang];

    return (langValue || '').trim();
  };

  useEffect(() => {
    let timerId: ReturnType<typeof setTimeout>;

    timerId = setTimeout(() => {
      navigateToHome(navigation);
    }, 10 * 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  const message = useMemo(() => {
    const welcomeMessage = getMessageByLang(ipadMeetingErrorMessage);

    return textReplace(welcomeMessage || '', i18n.language as IpadLang, customization, visit);
  }, [customization, visit]);

  return (
    <View style={styles.container}>
      <ContainerWidthLimit>
        <Header hideReturnButton />
        <View style={styles.content}>
          <View pointerEvents="none">
            <HTMLRender html={message} />
          </View>
        </View>
      </ContainerWidthLimit>
    </View>
  );
};

export default MeetingErrorScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
    alignItems: 'center',
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-evenly',
    paddingHorizontal: 64,
    textAlign: 'center',
  },
});
